
import * as types from '../actions/actionTypes'
import { assign } from 'lodash'

const host = window.location.hostname
const local = (host.indexOf("local") > -1);
const staging = host.indexOf('staging') > -1;
const develop = (host.indexOf('develop.') > -1)
const ROOT_URL = (local || develop)
  ? 'https://myphoto-api-develop.appspot.com'
  : (staging)
    ? 'https://myphoto-api-staging.appspot.com'
    : 'https://mp-cloud-api.appspot.com'

const initialState = {
  results: [{
      id: 1,
      altTxt: '',
      category:'',
      width: 1,
      height: 1,
      swatch: '',
      overlayWhite: '',
      overlayBlack: '',
      disabled: true
    }],
  overlays: [{
    id: 1,
    altTxt: '',
    category:'',
    width: 1,
    height: 1,
    swatch: '',
    overlayWhite: '',
    overlayBlack: '',
    disabled: true
  }],
  meta: {
    count: 0,
    totalCount: 0,
    pageCount: 0,
    self: `${ROOT_URL}/ovelrays?page=1`,
    previous: null,
    next: null,
    first: null,
    last: null,
    page: 1,
    limit: 20,
  },
  overlay: {}
}

function overlays(state = initialState, action) {
  switch (action.type) {
    case types.OVERLAYS_FETCH_SUCCESS:
      return assign({}, state, action.res);
    case types.OVERLAY_SET_SUCCESS:
      return assign({}, state, {
        overlays: action.res,
      });
    case types.OVERLAY_FETCH_SUCCESS:
      console.log('ACTION RES', action.res)
    case types.OVERLAY_EDIT_SUCCESS:
      return assign({}, state, {
        overlay: action.res,
      });
    case types.OVERLAY_DELETE_SUCCESS:
      return assign({}, state, {
        overlayDelete: action.res.ok,
      });
    case types.OVERLAY_CLEAR_ERRORS:
      return assign({}, state, {
        error: false,
      });
    case types.OVERLAYS_FETCH_ERROR:
    case types.OVERLAY_SET_ERROR:
    case types.OVERLAY_FETCH_ERROR:
    case types.OVERLAY_EDIT_ERROR:
    case types.OVERLAY_DELETE_ERROR:
        // console.log('OVERLAY ERROR, action.type', action.type)
        return assign({}, state, {
          error: action.res,
        })
    default:
    return state;
  }
}

export default overlays 


// WEBPACK FOOTER //
// ./src/reducers/overlays.js